<template>
    <div class="createVest spackage padding-20 bgc box-shadow">
        <section>
            <el-form :model="starMgtForm" :rules="rules" ref="starMgtForm" label-width="100px" class="starmgt-form">
                <el-form-item label="马甲名称" prop="name">
                    <el-input v-model="starMgtForm.name" placeholder="请输入马甲名称不超过10个字" maxlength="10" show-word-limit style="width: 260px"></el-input>
                </el-form-item>

                <el-form-item label="马甲头像" prop="headlogourl.furl" class="upload-image" required>
                    <div class="upload">
                        <upload style="width: 80px;height: 80px" class="avatar-uploader" :imgRule="imgRule"  @setImage="setCoverfile" :uploadType="uploadType" ref="coverfile"></upload>
                    </div>

                    <div class="position">
                        <!--<el-button type="warning" @click="dialogVisible = true">系统头像</el-button>-->
                        <p>建议上传尺寸80 * 80，jpg或png格式，不超过2M</p>
                    </div>
                </el-form-item>

                <el-form-item label="">
                    <el-button @click="back">取消</el-button>
                    <el-button style="margin-left: 30px;" type="primary" @click="submitForm()">保存</el-button>
                </el-form-item>
            </el-form>
        </section>
    </div>
</template>

<script>
    import Upload from 'base/upload/upload'
    import UploadFile from 'base/upload/uploadFile'
    import { saveAndUpdateStarsockpuppet, getSockpuppet } from '@/api/communityApi' // 引入星球管理 api 资源文件
    import {mapActions} from 'vuex' // 引入 vuex 组件
    import {formatFileInfo} from '@/common/js/tools' // 引入 tools 库

    import $ from 'jquery' // 引入 jquery 组件

    export default {
        name: "CreateStarMgt",
        data() {
            let validatelogodata = (rule, value, callback) => {
                if (!value) {
                    callback(new Error('请选择星球头像'))
                } else {
                    callback()
                    if(value.furl) {
                        this.starMgtForm.headlogourl = value.furl
                    }
                }
            }
            return {
                loading: false,
                imageUrl: '',   // 本地图片地址
                starMgtForm:{
                    name: '',
                    innerid: this.$route.query.starid,
                    starinnerid: this.$route.query.innerid,
                    headlogourl: {
                        bucket: '',
                        fname: '',
                        fsize: '',
                        width: '',
                        height: '',
                        key: '',
                        mimetype: '',
                        objecttype: '',
                        furl: ''
                    }
                },  // 接口参数
                imgRule: {
                    cls: 'icon_upload',
                    accept: 'image/png,image/jpeg',
                    size: 2,
                    width: '',
                    height: ''
                },
                uploadType: {
                    catecode: '95',
                    datatype: 'IMAGE'
                },
                rules: {
                    name: [
                        { required: true, message: '请输入马甲名称', trigger: 'blur' }
                    ],
                    headlogourl: [
                        { required: true, message: '请上传马甲头像', trigger: 'change' }
                    ]
                },
                updateImgStatus: false  // 更改图片操作状态 true 更改 false 未更改
            }
        },
        methods: {
            updateimg() {
                let reads = new FileReader(),
                    file = document.getElementById('file').files[0],
                    isJPG,
                    $this = this
                const isLt2M = file.size / 1024 / 1024 < 2;
                if(file.type === 'image/jpeg' || file.type === 'image/png') {
                    isJPG = true
                } else {
                    isJPG = false
                }

                if (!isJPG) {
                    this.$message.error('上传头像图片只能是 jpg/png 格式!')
                    return false
                }

                if (!isLt2M) {
                    this.$message.error('上传头像图片大小不能超过 2MB!')
                    return false
                }

                reads.readAsDataURL(file);

                reads.onload = function(){

                    $this.starMgtForm.headlogourl = $this.imageUrl = this.result
                    // 重置头像
                    $("input[name=headerimg]:checked").prop('checked',false)
                }
            },
            submitForm() {

                let updata = JSON.parse(JSON.stringify(this.starMgtForm))

                // 当头像图片发生变更时
                if( this.updateImgStatus ) {
                    updata.headlogourl.type = 'add'
                    updata.headlogourl = formatFileInfo(updata.headlogourl)
                } else {
                    updata.headlogourl = ''
                }
                this.setLoading(true)

                saveAndUpdateStarsockpuppet({
                    data: updata,
                    success: data => {
                        this.$message.success('保存成功')
                        this.setLoading(false)
                        this.back()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })

            },
            back() {
                this.$router.go(-1)
            },
            setCoverfile(img) {

                console.log('img',img)

                // 发生头像图片变更操作
                this.updateImgStatus = true

                $("input[name=headerimg]:checked").prop('checked',false)    // 清除选中头像
                this.starMgtForm.headlogourl = img
            },
            ...mapActions([
                'setLoading'
            ])
        },
        mounted() {
            if (this.starMgtForm.innerid) {
                // 编辑状态下
                let dataapi = {
                    starinnerid: this.starMgtForm.starinnerid,
                    innerid: this.starMgtForm.innerid
                }

                this.setLoading(true)
                getSockpuppet({
                    data: dataapi,
                    success:data => {
                        this.setLoading(false)
                        // this.starMgtForm = data.data
                        console.log('star',data.data)
                        this.$nextTick(() => {
                            let content = data.data
                            this.starMgtForm.name = content.name

                            this.$refs.coverfile.setImage(content.headlogourl)
                            this.starMgtForm.headlogourl.furl = content.headlogourl

                            // this.starMgtForm.headlogourl = content.headlogourl

                        })
                    },
                    error:data => {
                        this.setLoading(false)
                    }
                })
            }
        },
        components: {
            Upload,
            UploadFile
        }
    }
</script>

<style lang="scss" type="text/scss"  rel="stylesheet/scss">
    .createVest {
        .avatar-uploader {
            width: 80px;
            height: 80px;
        }
        .upload {
            float: left;
        }
        label {
            position: relative;
            display: inline-block;
            cursor: pointer;
            width:110px;
            box-sizing: border-box;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .position {
            margin-left: 30px;
            margin-top: 20px;
            float: left;
        }
    }
</style>
